import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#charges_svg__clip0_1730_103080)",
      stroke: "#2d6ded",
      strokeWidth: 2.57,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    /* @__PURE__ */ e.createElement("path", { d: "M16 31.335c8 0 13.715-2.834 13.715-9.142 0-6.858-3.429-11.429-10.286-14.858l2.697-3.474a1.508 1.508 0 00-1.28-2.286h-9.691a1.509 1.509 0 00-1.28 2.286l2.697 3.497C5.715 10.81 2.286 15.381 2.286 22.238 2.286 28.501 8 31.335 16 31.335z" }),
    /* @__PURE__ */ e.createElement("path", { d: "M20.81 25.285c-.673.29-1.399.44-2.133.437a6.155 6.155 0 01-5.866-6.4 6.155 6.155 0 015.866-6.4 5.212 5.212 0 011.74.288M10.146 17.722h6.4M10.146 20.92h6.4" })
  ),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "charges_svg__clip0_1730_103080" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", transform: "translate(0 .5)", d: "M0 0h32v32H0z" })))
);
export {
  a as default
};
